import messages from '../../../locale/messages';

const validate = (values) => {
  const errors = {};

  if (!values.hostId) {
    errors.hostId = messages.required;
  }

  return errors;
};

export default validate;
